import React, { useState } from 'react';

import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';

import LoadingPlaceholder from 'components/loadingPlaceholder';
import useResultProvider from 'dataProvider/hooks/useResultProvider';
import { MasterBar } from 'components';
import { getPlace } from '../../dataProvider';
import { TYPES, SUBTYPES } from '../../envs';
import Bars from '../../components/bars';

import './bars.scss';
import { useContextCurrentSite } from '../../contexts';
import { getSite, LOCALHOST } from '../../constants/sites';

const BarsContainer = () => {
  const { matchParams } = useContextMatchParams();
  const { year, type, electionNumber, placeId } = matchParams;

  const resultOrigin = useContextResultOrigin();

  const [place, setPlace] = useState(null);

  const excludes = [];

  const site = getSite();

  const { currentSite } = useContextCurrentSite();

  const { result: dataResult } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.primary?.active,
    year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber,
    placeId: type === TYPES.GENERAL ? 'C108' : placeId,
    site: site !== LOCALHOST ? site : currentSite
  });

  const { result: oldData } = useResultProvider({
    electionPlace: placeId,
    active: false,
    year: resultOrigin?.historic?.year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber: resultOrigin?.historic?.numElection,
    placeId: type === TYPES.GENERAL ? 'C108' : placeId,
    site: site !== LOCALHOST ? site : currentSite
  });

  getPlace({
    filter: `sortby=main&size=1&addid=${placeId}`,
    type,
    electionType: type
  }).then(_place => {
    setPlace(_place.content[0]);
  });

  if (!dataResult || !oldData || (type !== TYPES.GENERAL && !place)) {
    return <LoadingPlaceholder />;
  }
  return (
    <div className="bars_page">
      <MasterBar
        optionalTitleRegular={`Comparativa de ${
          type === TYPES.MUNICIPAL ? 'concejales' : 'escaños'
        } `}
        // optionalTitleStrong={`${place?.name || ''} ${dataResult.year} - ${
        // oldData.year
        // }`}

        // Si se quiere añadir la comunidad sustituir por las lineas comentadas
        optionalTitleStrong={`${dataResult.year} - ${oldData.year}`}
        isOpenedTabs={false}
      />
      <>
        <div className="barsWrapper">
          <Bars
            currentData={dataResult}
            pastData={oldData}
            year={year}
            electionNumber={electionNumber}
            electionType={type}
            placeId={placeId}
            excludes={excludes}
            factor={2}
          />
        </div>
        <p className="bars_page-leyend">
          {/* * En 2018, Por Andalucía y Adelante Andalucía concurrieron juntos */}
        </p>
      </>
    </div>
  );
};

export default BarsContainer;
